export { default as ENTRY } from './entry';

export const PROFILE_GA_CATEGORY = 'Profile';
export const PROFILE_PAGE_TYPE = 'ProfilePage';
export const DOCTOR_PATH = '/doctor/:providerId(/**)';
export const DENTIST_PATH = '/dentist/:providerId(/**)';
export const PROFESSIONAL_PATH = '/professional/:providerId(/**)';
export const PROVIDERS_PATH = '/providers/:providerId(/**)';

export const BasePaths = [
    DOCTOR_PATH,
    DENTIST_PATH,
    PROFESSIONAL_PATH,
    PROVIDERS_PATH,
];

export const pageName = 'provider profile';

// TODO: Centralize route handling such that we do not have to hardcode possible routes here.
export const profileRouteRegex = new RegExp('/(doctor|dentist|professional)/.*$');

export const PROVIDER_STATUS = {
    NewApplication: 1,
    ApprovedApplication: 2,
    Deleted: 4,
    Resource: 5,
    Locked: 60,
    Churned: 61,

    DEPRECATED: {
        DeclinedApplication: 3,
        PoachOrLockedOrHospitalDirectory: 6,
        UpgradeFromHospitalToSearchableDoc: 9,
    },
};

export const Sections = {
    Name: 'Name',
    Awards: 'Awards',
    Badges: 'Badges',
    BadgesV4: 'BadgesV4',
    Certifications: 'Certifications',
    Education: 'Education',
    HospitalAffiliations: 'HospitalAffiliations',
    InNetworkInsurance: 'InNetworkInsurance',
    InNetworkInsuranceMobileV4: 'InNetworkInsuranceMobileV4',
    Institutes: 'Institutes',
    Languages: 'Languages',
    Memberships: 'Memberships',
    NPI: 'NPI',
    OfficeLocation: 'OfficeLocation',
    OfficeLocations: 'OfficeLocations',
    Practice: 'Practice',
    Sex: 'Sex',
    Specialties: 'Specialties',
    Statement: 'Statement',
    Titles: 'Titles',
};
